import { render } from "./ContentPortal.vue?vue&type=template&id=c3fc4770&scoped=true"
const script = {}

import "./ContentPortal.vue?vue&type=style&index=0&id=c3fc4770&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3fc4770"]])

export default __exports__